import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import "../styles/header/header.css";
import ProfileAvatar from './users/UserProfile';
// import { getUserData } from './users/userstore';

import { useAuth } from "./context/AuthContext";
function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window !== "undefined") {
            return window.innerWidth <= breakpoint;
        }
        return false; // safe default for SSR
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
}


export default function Header({ hideNav = false, profileHide = false, hideHamburger = false, toggleMenu, padding }) {
    const [showMenu, setShowMenu] = useState(false);
    const [showProfileInfo, setShowProfileInfo] = useState(false);
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const location = useLocation();
    const { lang } = useParams();
    const switchLang = () => {
        const nextLang = lang === "en" ? "km" : "en";
        const currentPath = location.pathname.replace(/^\/lang\/(km|en)/, "");
        navigate(`/lang/${nextLang}${currentPath}`, { state: location.state });
    };

    const { logout, user } = useAuth();
    const [isAvatarActive, setIsAvatarActive] = useState(false);
    const username = user?.userName;
    const buttonRef = useRef(null);
    const menuRef = useRef(null);

    const handleClick = () => {
        setShowProfileInfo((prev) => !prev);
        setIsAvatarActive((prev) => !prev); // toggle active class
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowProfileInfo(false);
                setIsAvatarActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (

        <header className="header ant-layout-header main-header"  style={{ padding }}>
            <nav nav className="navbar" >
                <div className="nav-left-1">
                    <img src="/assets/logo-Horizontal.png" alt="Logo" className="logo" />
                    {/* {!hideNav && !isMobile && (
                        <div className="nav-left">
                            <a href="#how-it-works">{t('how-it-works')}</a >
                            <a href="#about-us">{t('about-us')}</a>
                        </div>
                    )} */}
                </div>


                <div className="nav-right">

                    <ul className="nav-right">
                        <li
                            onClick={switchLang}
                        >
                            <img
                                src={lang === "en" ? "/assets/united-kingdom-flag.png" : "/assets/cambodia-flag.png"}
                                alt={lang === "en" ? "English Language" : "Khmer Language"}
                                className="lang"
                            />
                        </li>
                    </ul>

                    {!hideNav && !isMobile && (
                        <li>
                            <button
                                className="login"
                                type="button"
                                onClick={() => {
                                    navigate(`/lang/${lang}/login`);
                                }}
                            >
                                {t('login')}
                            </button>
                        </li>
                    )}

                    {!isMobile && profileHide && user && (
                        <>
                            <div>
                                <button
                                    ref={buttonRef}
                                    className={`userProfile ${showProfileInfo ? "open" : ""}`}
                                    onClick={handleClick}
                                >
                                    <ProfileAvatar user={user} active={true} currentUser={user?.userName} />

                                    {!showProfileInfo ? (
                                        <svg className="icon-down" xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" /><path fill="currentColor" d="M13.06 16.06a1.5 1.5 0 0 1-2.12 0l-5.658-5.656a1.5 1.5 0 1 1 2.122-2.121L12 12.879l4.596-4.596a1.5 1.5 0 0 1 2.122 2.12l-5.657 5.658Z" /></g></svg>
                                    ) : (
                                        <svg className="icon-up" xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" /><path fill="currentColor" d="M10.94 7.94a1.5 1.5 0 0 1 2.12 0l5.658 5.656a1.5 1.5 0 1 1-2.122 2.121L12 11.122l-4.596 4.596a1.5 1.5 0 1 1-2.122-2.12z" /></g></svg>

                                    )}
                                </button>

                                <div className={`avatar${showProfileInfo ? " open" : ""}`} ref={menuRef}>
                                    <button
                                        className="profile"
                                        onClick={() => {
                                            navigate(`/lang/${lang}/files/${username}`);
                                            setShowProfileInfo((prev) => !prev);

                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" /></svg>

                                        <span>{user.email}</span>
                                    </button>
                                    <button
                                        className="logout"
                                        onClick={() => {
                                            logout();
                                            setShowProfileInfo(false);
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M14.945 1.25c-1.367 0-2.47 0-3.337.117c-.9.12-1.658.38-2.26.981c-.524.525-.79 1.17-.929 1.928c-.135.737-.161 1.638-.167 2.72a.75.75 0 0 0 1.5.008c.006-1.093.034-1.868.142-2.457c.105-.566.272-.895.515-1.138c.277-.277.666-.457 1.4-.556c.755-.101 1.756-.103 3.191-.103h1c1.436 0 2.437.002 3.192.103c.734.099 1.122.28 1.4.556c.276.277.456.665.555 1.4c.102.754.103 1.756.103 3.191v8c0 1.435-.001 2.436-.103 3.192c-.099.734-.279 1.122-.556 1.399s-.665.457-1.399.556c-.755.101-1.756.103-3.192.103h-1c-1.435 0-2.436-.002-3.192-.103c-.733-.099-1.122-.28-1.399-.556c-.243-.244-.41-.572-.515-1.138c-.108-.589-.136-1.364-.142-2.457a.75.75 0 1 0-1.5.008c.006 1.082.032 1.983.167 2.72c.14.758.405 1.403.93 1.928c.601.602 1.36.86 2.26.982c.866.116 1.969.116 3.336.116h1.11c1.368 0 2.47 0 3.337-.116c.9-.122 1.658-.38 2.26-.982s.86-1.36.982-2.26c.116-.867.116-1.97.116-3.337v-8.11c0-1.367 0-2.47-.116-3.337c-.121-.9-.38-1.658-.982-2.26s-1.36-.86-2.26-.981c-.867-.117-1.97-.117-3.337-.117z" /><path fill="currentColor" d="M15 11.25a.75.75 0 0 1 0 1.5H4.027l1.961 1.68a.75.75 0 1 1-.976 1.14l-3.5-3a.75.75 0 0 1 0-1.14l3.5-3a.75.75 0 1 1 .976 1.14l-1.96 1.68z" /></svg>
                                        {t("logout")}
                                    </button>
                                </div>
                            </div>

                        </>
                    )}


                    {isMobile && !hideHamburger && (
                        !profileHide ? (
                            <button
                                className="hamburger"
                                onClick={() => {
                                    navigate(`/lang/${lang}/login`);
                                    setShowMenu(false);
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 24 24"
                                >
                                    <g fill="none" stroke="currentColor" strokeWidth="1.1">
                                        <path
                                            strokeLinejoin="round"
                                            d="M4 18a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"
                                        />
                                        <circle cx="12" cy="7" r="3" />
                                    </g>
                                </svg>
                            </button>
                        ) : (
                            <button
                                className="hamburger"
                                onClick={toggleMenu}
                                aria-label="Toggle menu"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="24px"
                                    viewBox="0 -960 960 960"
                                    width="24px"
                                    fill="#374151"
                                >
                                    <path d="M160-240q-17 0-28.5-11.5T120-280q0-17 11.5-28.5T160-320h640q17 0 28.5 11.5T840-280q0 17-11.5 28.5T800-240H160Zm0-200q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h640q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H160Zm0-200q-17 0-28.5-11.5T120-680q0-17 11.5-28.5T160-720h640q17 0 28.5 11.5T840-680q0 17-11.5 28.5T800-640H160Z" />
                                </svg>
                            </button>
                        )
                    )}

                </div>
            </nav >

            {/* {
                isMobile && (
                    <div className={`drawer ${showMenu ? "open" : ""}`} ref={menuRef}>
                        <button
                            className="drawer-close"
                            onClick={() => setShowMenu(false)}
                            aria-label="Close menu"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#374151"><path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z" /></svg>
                        </button>


                        <div className="nav-links">
                            <a href="#how-it-works" onClick={() => setShowMenu(false)}>
                                {t("how-it-works")}
                            </a>
                            <a href="#about-us" onClick={() => setShowMenu(false)}>
                                {t("about-us")}
                            </a>
                        </div>

                        {(
                            !profileHide ? (
                                <button
                                    className="login"
                                    onClick={() => {
                                        navigate(`/lang/${lang}/login`);
                                        setShowMenu(false);
                                    }}
                                >
                                    {t("login")}
                                </button>
                            ) : (
                                <button
                                    className="profile"
                                    onClick={() => {
                                        navigate(`/lang/${lang}/files/${username}`);
                                        setShowMenu(false);

                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" /></svg>
                                    <span>{user?.email}</span>
                                </button>

                            )
                        )}
                    </div>
                )
            } */}

        </header >

    );
};
